var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArtsyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.14 27.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.85,1.85H77.29V25.44H45.37V21.55h-1.8v3.89H1.85ZM0,27.29H79.14V0H0ZM16.05,8.79H14L10.5,17.86h2l.92-2.51h3.19l.91,2.51h2ZM14,13.69l1-2.85,1,2.85Zm22.84-3.1v7.27h1.9V10.59h3.2V8.79H33.67v1.8Zm27,2.07L61.6,8.79H59.38l3.55,5.74v3.33h1.91V14.53L68.4,8.79H66.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.57,13.09a6.29,6.29,0,0,0-2.11-.81L53,12.17l-.09,0c-.58-.15-1.38-.35-1.38-1s.87-.94,1.38-.94a1.33,1.33,0,0,1,1.48,1v0h1.8v0C56.16,9.49,55,8.53,53,8.53c-1.48,0-3.21.7-3.21,2.64s1.81,2.46,3.4,2.84l.43.1c.8.21,1.22.59,1.22,1.12,0,1.14-1.5,1.2-1.8,1.2-1,0-1.62-.39-1.79-1.23v0H49.41v0A2.34,2.34,0,0,0,50,16.91a4,4,0,0,0,3,1.17c1.74,0,3.6-.9,3.6-2.88a2.62,2.62,0,0,0-1-2.11M29.39,14a2.91,2.91,0,0,0,1.13-2.34,2.86,2.86,0,0,0-1.36-2.45A3.81,3.81,0,0,0,27,8.79H22.94v9.08h1.92V13.38l3.57,4.49h2.33l-2.71-3.33A3,3,0,0,0,29.39,14m-4.53-1V10.5H27a1.88,1.88,0,0,1,1.12.24,1.19,1.19,0,0,1,.46,1c0,.82-.58,1.23-1.73,1.23h-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtsyLogo);
export default __webpack_public_path__ + "static/media/ArtsyLogo.4e6ed658460a1ea84bee07a810322066.svg";
export { ForwardRef as ReactComponent };